import { useEffect, useState } from "react";
import { AccessWay } from "./AccessWay";
import { clamp } from "../../utils/math";
import ModalComponent from "../../components/Modal/ModalComponent";
import EventDetails from "../Events/EventDetails/EventDetails";
import { useTranslation } from "react-i18next";

export function Ways({ events, ...props }) {
	const [height, setHeight] = useState(350);
	const [evtns, setEvents] = useState(events);
	const [receptionCardSelected, setReceptionCardSelected] = useState();
	const [modalUserDetail, setModalUserDetail] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		setEvents(events.slice(1, events.length))
	}, [events]);

	const handleClickReceptionCard = (event) => {
		setModalUserDetail(true);
		setReceptionCardSelected(event);
	};

	const handleConfirm = () => {
		setModalUserDetail(false);
	};

	const handleCancel = () => {
		setModalUserDetail(false);
	};

	useEffect(() => {
		function calculateHeight() {
			const waysContainer = document.querySelector('.ways-container');
			const wayColumns = document.querySelectorAll('.way-column');
			if (waysContainer && wayColumns.length === 2) {
				const waysHeight = waysContainer.clientHeight;
				const dvh = window.innerHeight - 40;
				const waysRect = waysContainer.getBoundingClientRect();
				const availableHeight = dvh - (waysRect.top + waysHeight);
				setHeight(clamp(350, Infinity, waysHeight + availableHeight));
			}
		}

		calculateHeight();
		window.addEventListener('resize', calculateHeight);
		return () => window.removeEventListener('resize', calculateHeight);
	}, []);

	return (
		<>
			<div className="ways-container" style={{ height: `${height}px` }}>
				<AccessWay events={events} height={height} handleClickReceptionCard={handleClickReceptionCard} way={'enter'} />
				<AccessWay events={events} height={height} handleClickReceptionCard={handleClickReceptionCard} way={'exit'} />
			</div>
			<ModalComponent
				modalIsOpen={modalUserDetail}
				hideConfirmButton={true}
				handleCancel={handleCancel}
				buttonLabel2={t("common.close")}
			>
				<EventDetails
					isReception={true}
					title={t("common.accessDetails")}
					lastAccess={receptionCardSelected}
				/>
			</ModalComponent>
		</>
	);
}